/* @flow */
import type { Map } from 'immutable';
import { getQueryParams } from 'trustar/utils';
import createDebugger from 'debug';

const debug = createDebugger('app:modules:enclave:actions'); // eslint-disable-line no-unused-vars

import { type RawOptions } from 'modules/enclave/types.js';
import {
  FETCH,
  FETCH_WITH_QUERY,
  SET_QUERY_RESULTS,
  SAVE,
  DELETE,
  SET_DISPLAY_OPTIONS,
} from './action-types.js';
import {SAVE_ENCLAVE_ICON, SAVE_TEMPLATE_ICON} from '../icons/action-types';

/**
 * Fetch all enclaves that the user has access to. This means that TruSTAR admin
 * users will receive all enclaves, and everyone else will have access to only
 * the enclaves they has access to as a user.
 */
export const fetch = (payload: ?Object = getQueryParams()) => ({
  type: FETCH,
  payload
});

/**
  Fetch user enclaves
 */
export const fetchWithQuery = (payload: ?Object = getQueryParams()) => ({
  type: FETCH_WITH_QUERY,
  payload
});
/**
  Fetch user enclaves
 */
export const setQueryResults = (payload: Object) => ({
  type: SET_QUERY_RESULTS,
  payload
});

/**
 * Save an enclave
 */
export const saveEnclave = (enclave: Map<any, any>, marketplaceImageFile: ?File = null, sourceSVGFile: ?File = null): Object => ({
  type: SAVE,
  payload: enclave,
  meta: {
    file: marketplaceImageFile,
    sourceSVGFile,
  }
});

export const saveEnclaveIcon = (enclaveGuid: string, file?: File) => ({
  type: SAVE_ENCLAVE_ICON,
  payload: {
    guid: enclaveGuid,
    file,
  }
});

/**
 * Delete enclave by id
 */
export const deleteEnclave = (id: number): Object => ({
  type: DELETE,
  payload: id,
});

/**
 * Set display options. Determines sorting and filtering of Enclaves displayed to admins.
 */
export const setDisplayOptions = (options: RawOptions): Object => ({
  type: SET_DISPLAY_OPTIONS,
  payload: options,
});



// WEBPACK FOOTER //
// ./src/app/modules/enclave-management/actions.js